import { render, staticRenderFns } from "./giftManage.vue?vue&type=template&id=dffa8786&scoped=true&"
import script from "./giftManage.vue?vue&type=script&lang=js&"
export * from "./giftManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffa8786",
  null
  
)

export default component.exports